import React from "react";
import InboxIcon from "@mui/icons-material/Inbox";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

const containerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "16px",
};

const baseCardStyle = {
  background: "#fff",
  borderRadius: "10px",
  padding: "18px 14px",
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  display: "flex",
  alignItems: "center",
  gap: "21px",
  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px)",
};

const iconBoxStyle = {
  backgroundColor: "#F26639",
  width: "38px",
  height: "38px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  flexShrink: 0,
};

const textContainer = {
  display: "flex",
  flexDirection: "column",
};

const countStyle = {
  fontSize: "18px",
  fontWeight: "600",
  color: "#000",
  lineHeight: "20px",
  marignBottom:"7px"
};

const labelStyle = {
  fontSize: "13px",
  color: "#000",
  marginTop:"6px"
};

const SkillAssessmentDashboardCards = ({
  app_side_completed,
  app_side_pending,
  approved_count,
  decline_count,
  pending_count,
  total_count,
}) => {
  const cardData = [
    { label: "Total", key: "total_count", value: total_count ? total_count : 0, icon: <InboxIcon fontSize="small" /> },
    { label: "Pending", key: "pending_count", value: pending_count ? pending_count : 0, icon: <PendingActionsIcon fontSize="small" /> },
    { label: "Approved", key: "approved_count", value: approved_count ? approved_count : 0 ? approved_count : 0, icon: <CheckCircleIcon fontSize="small" /> },
    { label: "Declined", key: "decline_count", value: decline_count ? decline_count : 0, icon: <CancelIcon fontSize="small" /> },
    { label: "Completed in App", key: "app_side_completed", value: app_side_completed ? app_side_completed : 0, icon: <TaskAltIcon fontSize="small" /> },
    { label: "Pending in App", key: "app_side_pending", value: app_side_pending ? app_side_pending : 0, icon: <HourglassBottomIcon fontSize="small" /> },
  ];

  return (
    <div style={containerStyle}>
      {cardData.map((item) => (
        <div key={item.key} style={baseCardStyle}>
          <div style={iconBoxStyle}>{item.icon}</div>

          <div style={textContainer}>
            <div style={countStyle}>{item.value}</div>
            <div style={labelStyle}>{item.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkillAssessmentDashboardCards;